import styled from 'styled-components';

export const List = styled.ul`
    margin: 0 !important;
    padding-left: 16px;

    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ListItem = styled.li`
    list-style: disc;
    padding-left: 4px;
`;
